import React from "react";
import { Polyline } from "react-leaflet";
import { LocationData, SpotData } from "../datastructures";

interface SpotLocationLineProps {
  spot: SpotData;
  location: LocationData;
}

export const SpotLocationLine: React.FC<SpotLocationLineProps> = ({
  spot,
  location,
}) => {
  if (!spot || !location) return null;
  return (
    <Polyline
      key={"line_" + spot.id + "_" + location.id}
      positions={[
        [spot.n, spot.e],
        [location.n, location.e],
      ]}
      pathOptions={{
        color: "#1976d2",
        weight: 2,
        dashArray: "4 6",
      }}
    />
  );
};
